export default __webpack_public_path__ + "static/not-found-logo-2fe22f036c3baa4906b447a833e0a645.png";